import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router";
import Home from './Home'


import "../App.css";

import { auth } from "../App";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginErrorMessage, setLoginErrorMessage] = useState("")
  const history = useHistory();

  if (localStorage.getItem('claim') !== 'offline') {
    return <Home />
  }
  const changeEmail = (e) => {
    setEmail(e.target.value);
  };

  const changePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .then((user) => {
        // console.log(user);
        localStorage.setItem("user", user.user.uid);
        history.push("/home");
      })
      .catch((error) => {
        setLoginErrorMessage("")
        if (error.code === "auth/wrong-password") {
          console.log("password not found");
          setLoginErrorMessage("badPassword")
        } else if (error.code === "auth/user-not-found") {
          console.log("username not found")
          setLoginErrorMessage("badUser")
        } else {
          console.log(error);
          setLoginErrorMessage("otherError")
        }
      });
  };

  return (
    <Grid container>
      <Grid item sm />
      <Grid item sm>
        <Typography variant="h2">Login</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            id="Email"
            label="Email"
            type="email"
            onChange={changeEmail}
            fullWidth
          />
          <TextField
            id="Password"
            label="Password"
            type="password"
            onChange={changePassword}
            fullWidth
          />
          <div className="loginSignUpButton">
            <Button type="submit" variant="contained" color="primary">
              Login
            </Button>
          </div>
        </form>
        {loginErrorMessage === "badPassword" &&
          <div className="loginSignUpError">Wrong password.</div>
        }
        {loginErrorMessage === "badUser" &&
          <div className="loginSignUpError">Wrong username.</div>
        }
        {loginErrorMessage === "otherError" &&
          <div className="loginSignUpError">Another login error.</div>
        }
        {/* <SignOut></SignOut> */}
      </Grid>
      <Grid item sm />
    </Grid>
  );
}

export default Login;
